import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import { CreateProfileRequest, EditProfileRequest, ProfileResponse, InsertRoleBulkRequest, Role } from '@models'

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly profileBaseUrl = `${environment.cms_latam_api.baseUrl}/profile/profile`
  private readonly roleBaseUrl = `${environment.cms_latam_api.baseUrl}/role/role`

  constructor(private http: HttpClient) {}

  // ---------- Profiles ----------

  async getAll(): Promise<ProfileResponse[]> {
    return await firstValueFrom(this.http.get<ProfileResponse[]>(`${this.profileBaseUrl}/getAll`))
  }

  async getAllProfiles(): Promise<ProfileResponse[]> {
    return await firstValueFrom(this.http.get<ProfileResponse[]>(`${this.profileBaseUrl}/getAllProfiles`))
  }

  async getById(profileId: number): Promise<ProfileResponse> {
    return await firstValueFrom(this.http.get<ProfileResponse>(`${this.profileBaseUrl}/${profileId}`))
  }

  async create(payload: CreateProfileRequest): Promise<number> {
    return await firstValueFrom(this.http.post<number>(this.profileBaseUrl, payload))
  }

  async update(payload: EditProfileRequest): Promise<number> {
    return await firstValueFrom(this.http.put<number>(this.profileBaseUrl, payload))
  }

  async delete(id: number): Promise<void> {
    return await firstValueFrom(this.http.delete<void>(`${this.profileBaseUrl}/${id}`))
  }

  // ---------- Roles ----------

  async insertRoleBulk(payload: InsertRoleBulkRequest): Promise<void> {
    return await firstValueFrom(this.http.post<void>(`${this.roleBaseUrl}/insertBulk`, payload))
  }

  async deleteAllRoles(profileId: number): Promise<void> {
    return await firstValueFrom(
      this.http.delete<void>(`${this.roleBaseUrl}/deleteAllRolesByProfileId`, {
        params: { profileId: profileId.toString() },
      })
    )
  }

  async getRolesByProfileId(profileId: number): Promise<Role[]> {
    return await firstValueFrom(
      this.http.get<Role[]>(`${this.roleBaseUrl}/getRoles`, {
        params: { profileId: profileId.toString() },
      })
    )
  }
}
